import { useGetPartnerDetailAPI } from "@/api/partners/usePartnersAPI";
import GeneralLoadingSplashscreen from "@/assets/svg/generalLoadingSplashscreen.svg?react";
import { MESSAGE } from "@/constants/message";
import { getSubdomain } from "@/utils/location";

const LoadingPage = () => {
  const { data } = useGetPartnerDetailAPI(getSubdomain());

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-teal-50 p-8">
      <div className="shrink-0">
        {data?.app_logo_url ? (
          <img
            src={data.app_logo_url}
            alt={data.name ?? "Partner logo"}
            className="max-h-32 w-auto"
          />
        ) : (
          <GeneralLoadingSplashscreen className="flex-1" />
        )}
      </div>
      <p className="text-2xl text-center font-bold text-txtHeading mt-10">
        {MESSAGE.LOADING_PAGE_TITLE}
      </p>
      <p className="text-2xl text-center font-bold text-txtHeading">
        {MESSAGE.LOADING_PAGE_DESCRIPTION}
      </p>
    </div>
  );
};

export default LoadingPage;
